import { API } from 'aws-amplify'

import {
  createDgtPdIAMUser,
  updateDgtPdIAMUser,
  createUserCognito,
  addUserToAdminsCognito,
  resetPassword
} from '../graphql/mutations'

import {
  getDgtPdIAMUser,
  getUserStatus,
} from '../graphql/queries'

import { DgtPdIAMUser } from '../models'

export const getUser = (usr: string) => {
  const user: any = API.graphql({
    query: getDgtPdIAMUser,
    variables: { username: usr.toLowerCase() }
  })
  return user
}

export const newUser = async (user: DgtPdIAMUser, isSSO: boolean) => {
  const input : any = {
    username: user.username,
    employeeNo: user.employeeNo,
    firstName: user.firstName,
    lastName: user.lastName,
    department: user.department,
    roles: user.roles
  }
  if (user.email) input['email'] = user.email
  if (user.division) input['division'] = user.division
  if (user.line) input['line'] = user.line
  if (user.isAdmin) input['isAdmin'] = user.isAdmin

  const postResult : any = await API.graphql({
    query: createDgtPdIAMUser,
    variables: { input }
  })

  console.log('post ddb completed', postResult)

  if (isSSO) return
  
  const posted : any = await API.graphql({
    query: createUserCognito,
    variables: { username: user.username }
  })
  const createUserResponse = JSON.parse(posted.data?.createUserCognito)
  if (createUserResponse.statusCode === 400) throw new Error("UsernameExistsException");
  
  console.log('post cognito completed', createUserResponse)

  if (!user.isAdmin) return

  const postedAdmin : any = await API.graphql({
    query: addUserToAdminsCognito,
    variables: { username: user.username, isRemove: false }
  })
  console.log(postedAdmin)
  const addAdminResponse = JSON.parse(postedAdmin.data?.addUserToAdminsCognito)
  if (addAdminResponse.statusCode === 400) throw new Error("UsernameNotExistException");

  console.log('update user to group cognito completed', addAdminResponse)
}

export const updateUser = async (username: string, editData: DgtPdIAMUser) => {
  const user: any = await API.graphql({
    query: getDgtPdIAMUser,
    variables: { username }
  })
  if (user.data?.getDgtPdIAMUser) {
    const updateResult : any = await API.graphql({
      query: updateDgtPdIAMUser,
      variables: { input: {
        ...editData,
        username,
        _version: user.data?.getDgtPdIAMUser._version
      }}
    })
    if (updateResult.data) {
      const isAdminChanged = editData.isAdmin !== user.data?.getDgtPdIAMUser.isAdmin
      console.log('isAdminChanged', isAdminChanged)
      if (isAdminChanged) {
        const postedAdmin : any = await API.graphql({
          query: addUserToAdminsCognito,
          variables: { username, isRemove: !editData.isAdmin }
        })
        const addAdminResponse = JSON.parse(postedAdmin.data?.addUserToAdminsCognito)
        if (addAdminResponse.statusCode === 400) throw new Error("UsernameNotExistException");

        console.log('update user to group cognito completed', addAdminResponse)
      }
      return updateResult.data.updateDgtPdIAMUser
    }
  }
  throw Error('not found')
}

export const getCognitoUserStatus = async (username: string) => {
  const getResult: any = await API.graphql({
    query: getUserStatus,
    variables: { username }
  })
  const returnResult = getResult.data?.getUserStatus
  const userInfo = JSON.parse(returnResult)
  return userInfo
}

export const resetCognitoPassword = async (username: string) => {
  const postResult: any = await API.graphql({
    query: resetPassword,
    variables: { username }
  })
  const returnResult = postResult.data?.resetPassword
  const response = JSON.parse(returnResult)
  if (response.statusCode === 400) throw new Error(response.message);
}